import * as types from "../types";

const state = {
  informations: [],
};

const getters = {
  informations: (state) => state.informations,
};

const mutations = {
  [types.ADD_NOTIFICATION](state, information) {
    information.hash = Date.now();
    state.informations.push(information);
  },
};

const actions = {
  [types.PUSH_NOTIFICATION]({ commit }, information) {
    // // eslint-disable-next-line
    // debugger;
    commit(types.ADD_NOTIFICATION, information);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
